import React from 'react'

export default [
  {
    name: 'Original',
    svg: `
      <feComponentTransfer in="SourceGraphic">
        <feFuncR type="table" tableValues=".07 .22 .57 .85 1" />
        <feFuncG type="table" tableValues=".07 .22 .57 .85 1" />
        <feFuncB type="table" tableValues=".09 .22 .57 .85 1" />
      </feComponentTransfer>
    `
  },
  {
    name: 'Retro',
    svg: `
      <feComponentTransfer in="SourceGraphic">
        <feFuncR type="table" tableValues=".01 .20 .85 1" />
        <feFuncG type="table" tableValues=".1  .20 .70 1" />
        <feFuncB type="table" tableValues=".2  .35 .65 .9" />
      </feComponentTransfer>
    `
  },
  {
    name: 'B&W',
    svg: `
      <feColorMatrix in="SourceGraphic" type="saturate" values="0" result="blackAndWhite" />
      <feComponentTransfer in="blackAndWhite">
        <feFuncR type="table" tableValues=".01 .25 .82 1" />
        <feFuncG type="table" tableValues=".01 .25 .82 1" />
        <feFuncB type="table" tableValues=".01 .25 .82 1" />
      </feComponentTransfer>
    `
  },
  {
    name: 'Soft',
    svg: `
      <feComponentTransfer in="SourceGraphic">
        <feFuncR type="table" tableValues=".1  .45 .82 1" />
        <feFuncG type="table" tableValues=".1  .45 .8 1" />
        <feFuncB type="table" tableValues=".2  .45 .8 .9" />
      </feComponentTransfer>
      <feColorMatrix type="saturate" values="1.4" />
    `
  },
]
